
import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";



// OBTENER TODOS LAS terms
export const getTerms = async () => {
    const respuesta = await PrivateInterceptor(`Compras/Terms`, "GET");
    return respuesta;
  };


  // AGREGAR TERMS
  export const addTerms = async (data) => {
    const respuesta = await PrivateInterceptor(`Compras/Terms/add`, "POST", data);
    return respuesta;
  };

  export const getTermTypePaymentTerms = async () => {
    const respuesta = await PrivateInterceptor(`Compras/Terms/TypePaymentTerms`, "GET");
    return respuesta;
  };

  export const getTermIncoTerms = async () => {
    const respuesta = await PrivateInterceptor(`Compras/Terms/TypeIncoTerms`, "GET");
    return respuesta;
  };
  
  
//   export const getPosicionesAct = async () => {
//     const respuesta = await PrivateInterceptor(`Suministros/Posiciones/PosicionesAct`, "GET");
//     return respuesta;
//   };
  
//   // MODIFICAR POSICION
//   export const modificarPosicion = async (data) => {
//     const respuesta = await PrivateInterceptor(`Suministros/Posiciones/add`, "POST", data);
//     return respuesta;
//   };
  
